import React, { useState, useEffect } from 'react'
// import CssBaseline from '@material-ui/core/CssBaseline'
import Footer from '../components/Footer';
import NavbarHeader from '../components/NavbarHeader';
import AssetViewer from '../components/CrewBuilderForms';
import { Account } from '../components/Accounts'

function CrewBuilder() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Account>
            <NavbarHeader toggle={toggle} />
            <AssetViewer />
            <Footer />
        </Account>
    );
}

export default CrewBuilder;